import { render, staticRenderFns } from "./setWorkTime.vue?vue&type=template&id=22d718c0&scoped=true"
import script from "./setWorkTime.vue?vue&type=script&lang=js"
export * from "./setWorkTime.vue?vue&type=script&lang=js"
import style0 from "./setWorkTime.vue?vue&type=style&index=0&id=22d718c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d718c0",
  null
  
)

export default component.exports